/** See `src/i18n/locales/en/statistics.ts`. */
export const statistics = {
  panelType: {
    series: 'Série',
    sessions: 'Séances',
    availability: 'Disponibilité',
  },
  status: {
    forbidden: "Vous n'êtes pas autorisé à voir ceci.",
    insufficientData:
      "Pas encore assez de personnes n'ont de données pour que ce groupe soit affiché sans identifier quelqu'un.",
    noMetrics: 'Aucune mesure sur cette période.',
    noData: 'Aucune donnée sur cette période.',
    noSessions: 'Aucune séance sur cette période.',
    noAvailability: 'Aucune donnée enregistrée.',
    loadFailed: "Ce panneau n'a pas pu être chargé : {{message}}",
  },
  target: {
    you: 'Vous',
    department: 'Département {{name}}',
    company: 'Entreprise {{name}}',
  },
  table: {
    date: 'Date',
    type: 'Type',
    duration: 'Durée',
    calories: 'Calories',
    avgHeartRate: 'FC moy.',
    minutes: '{{count}} min',
    metric: 'Mesure',
    source: 'Source',
    first: 'Première',
    last: 'Dernière',
    days: 'Jours',
  },
  detailLink: 'Voir les détails',
  range: {
    last7Days: '7 derniers jours',
    last30Days: '30 derniers jours',
    last90Days: '90 derniers jours',
    thisWeek: 'Cette semaine',
    thisMonth: 'Ce mois-ci',
    custom: 'Personnalisé…',
    from: 'Du',
    to: 'Au',
  },
} as const;
